import * as React from 'react';
import {render} from 'react-dom';
import {Provider} from 'react-redux';
import * as Modal from 'react-modal';

import 'core-js/shim';
import 'whatwg-fetch';

import App from './components/App';
import store from './store';
import '../sass/index.scss';

const fixture: HTMLElement = document.getElementById('fixture');
Modal.setAppElement(fixture);

render(
	<Provider store={store}>
		<App />
	</Provider>
, fixture);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/main.tsx